/**
 * 班级卡片
 */
export default {
  groupBuy: '拼團優惠',
}
